import { serverHost } from "variables/serverdata";

function getAuthToken() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return localStorage.getItem("token");
    const parsed = JSON.parse(raw);
    return parsed?.access_token || parsed?.token || parsed?.accessToken || null;
  } catch (e) {
    return localStorage.getItem("token");
  }
}

export async function insertSipProfile(sipProfile, domains, settings) {
  const token = getAuthToken();
  const res = await fetch(`${serverHost}/create_sip_profile`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ sipProfile, domains, settings }),
  });
  return res.json();
}

export async function updateSipProfile(sipProfile, domains, settings) {
  if (!sipProfile.sip_profile_uuid) throw new Error("Missing sip_profile_uuid");
  const token = getAuthToken();
  const res = await fetch(`${serverHost}/update_sip_profile/${sipProfile.sip_profile_uuid}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ sipProfile, domains, settings }),
  });
  return res.json();
}

export async function getSipProfile(profile_uuid) {
  const token = getAuthToken();
  const res = await fetch(`${serverHost}/get_sip_profile/${profile_uuid}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.json();
}
